import { render, staticRenderFns } from "./campaign.vue?vue&type=template&id=44bcadd0&"
import script from "./campaign.vue?vue&type=script&lang=js&"
export * from "./campaign.vue?vue&type=script&lang=js&"
import style0 from "./campaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports